import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import Datetime from 'react-datetime'

// import actions
// import { getEmployeePunchTimes } from './../../../actions/punchclock'

// import styles
import './newpunchmodal.scss'

// Utils
// import { renderFullDate } from '../../../utils/time'
import { translation } from '../../../utils/helpers'

// import components
import Modal from '../../components/Modal'

// Elements
import Check from '../../elements/check'
import Text from '../../elements/text'
import DateTime from '../../elements/datetime'
import Inline from '../../elements/inline'

class NewPunchModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      show: false,
      selDate: '',
      selIn: '00:00',
      selOut: '00:00',
      selAwayType: null
    }
    this.saveEntry = this.saveEntry.bind(this)
    this.renderContent = this.renderContent.bind(this)
    this.setHourMin = this.setHourMin.bind(this)
    // this.onInputChange = this.onInputChange.bind(this)
  }

  componentWillReceiveProps (props) {
    if (props.show !== this.state.show) {
      this.setState({
        show: props.show
      })
    }
  }

  saveEntry (e) {
    e.preventDefault()
    if (this.state.selDate === null || this.state.selDate === '') return
    let entry = {
      PunchClockStatId: 0,
      PunchIn: null,
      PunchOut: null,
      AwayDate: null,
      ModifiedByAdmin: false,
      CheckVacation: false,
      CheckSick: false,
      CheckSickChild: false,
      CheckPaidAbsence: false,
      CheckUnPaidAbsence: false
    }

    let datePart = this.state.selDate.format('YYYY-MM-DD')
    let timePart = this.state.selDate.format('HH:mm:ss')

    if (this.state.selAwayType !== null) {
      entry.AwayDate = datePart + ' ' + timePart
      entry.PunchIn = null
      entry.PunchOut = null
      switch (this.state.selAwayType) {
        case 0:
          entry.CheckVacation = true
          break
        case 1:
          entry.CheckSick = true
          break
        case 2:
          entry.CheckSickChild = true
          break
        case 3:
          entry.CheckPaidAbsence = true
          break
        case 4:
          entry.CheckUnPaidAbsence = true
          break
      }
    } else {
      entry.AwayDate = null
      entry.PunchIn = this.setHourMin(datePart + ' ' + timePart, this.state.selIn)
      entry.PunchOut = this.setHourMin(datePart + ' ' + timePart, this.state.selOut)
    }

    console.log('Create entry: ', entry)
    this.props.saveNewEntry(entry)
  }

  setHourMin (dateTime, hhmm) {
    // Format is 2017-04-02T10:41:16
    if (hhmm !== null && hhmm.length === 4) {
      if (hhmm.indexOf(':') === -1) {
        hhmm = hhmm.substring(0, 2) + ':' + hhmm.substring(2, 4)
      } else if (hhmm.indexOf(':') === 1) {
        hhmm = '0' + hhmm
      }
    }
    if (dateTime === null) return hhmm
    return dateTime.substring(0, 11) + hhmm
  }

  renderContent () {
    const onDateChange = (e) => {
      this.setState({
        selDate: e
      })
    }

    const onChangeTime = (e) => {
      let value = e.target.value
      let punchIn = this.state.selIn
      let punchOut = this.state.selOut
      if (value === '') value = null
      if (e.target.name === 'punchIn') {
        punchIn = this.setHourMin(null, value)
      } else if (e.target.name === 'punchOut') {
        punchOut = this.setHourMin(null, value)
      }
      this.setState({
        selIn: punchIn,
        selOut: punchOut
      }, () => {
        console.log('state', this.state)
      })
    }

    const onChangeAwayType = (e) => {
      // e.preventDefault()
      console.log(e.target, e.target.checked)
      let value = parseInt(e.target.value)
      let checked = e.target.checked
      if (!checked) value = null
      this.setState({
        selAwayType: value
      }, () => {
        console.log('state', this.state)
      })
    }

    return (
      <div>
        <DateTime
          inputProps={{
            name: 'date',
            readOnly: true,
            placeholder: translation('1728')
          }}
          dateFormat='DD-MM-YYYY'
          timeFormat={false}
          closeOnSelect
          value={this.state.selDate}
          onChange={onDateChange}
          labelText={translation('388')} />
        <Inline block>
          <Text name='punchIn' value={this.state.selIn} onChange={onChangeTime} maxLength='5' labelText={translation('438')} />
          <Text name='punchOut' value={this.state.selOut} onChange={onChangeTime} maxLength='5' labelText={translation('439')} />
        </Inline>

        <Check id='away_0' name='away_0' value='0' onChange={onChangeAwayType} checked={this.state.selAwayType === 0} labelText={translation('500')} />
        <Check id='away_1' name='away_1' value='1' onChange={onChangeAwayType} checked={this.state.selAwayType === 1} labelText={translation('508')} />
        <Check id='away_2' name='away_2' value='2' onChange={onChangeAwayType} checked={this.state.selAwayType === 2} labelText={translation('502')} />
        <Check id='away_3' name='away_3' value='3' onChange={onChangeAwayType} checked={this.state.selAwayType === 3} labelText={translation('1436')} />
        <Check id='away_4' name='away_4' value='4' onChange={onChangeAwayType} checked={this.state.selAwayType === 4} labelText={translation('1435')} />
      </div>
    )
  }

  render () {
    let modalTitle = translation('2210')

    return (
      <div className='newpunch__modal'>
        <Modal
          {...this.props}
          header={modalTitle}
          bottomBarProps={{
            actionLabelText: translation('27'),
            onActionClick: this.saveEntry
          }}
        >
          {this.renderContent()}
        </Modal>
      </div>
    )
  }
}

NewPunchModal.propTypes = {
  saveNewEntry: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { /* getEmployeePunchTimes */ })(NewPunchModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewPunchModal/index.js